<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="模板名称" name="template_name"></c-form-item>
					<c-form-item type="datetime" label="生效时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="templateState"></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
        <c-button color="sys" power="b_decorate_template_pc_edit"  icon="add" @click="editTemplate(0)">新增模板</c-button>
      </m-operate>
			<c-table ref="table" code="decorate_template_list_pc">
				<c-table-column label="状态" name="state" width="80">
					<template v-slot="{data}">
						<span v-if="data.state == 0" style="color:red">未生效</span>
						<span v-else-if="data.state == 1" style="color:darkgreen">生效中</span>
						<span v-else-if="data.state == 2" style="color:#999">已过期</span>
          </template>
				</c-table-column>
				<c-table-column label="模板名称" name="template_name" width="280"></c-table-column>
				<c-table-column label="备注" name="remark" width="300"></c-table-column>
				<c-table-column label="生效时间" name="effective_start_date" width="140">
          <template v-slot="{data}">
            <span v-if="data.id > 0 && data.state == 0" style="color:red">{{data.effective_start_date}}</span>
            <span v-if="data.id > 0 && data.state == 1" style="color:darkgreen">{{data.effective_start_date}}</span>
            <span v-if="data.id > 0 && data.state == 2" style="color:#999">{{data.effective_start_date}}</span>
            <span v-if="data.id < 0">--</span>
          </template>
        </c-table-column>
				<c-table-column type="button" fixed="right" label="操作" width="160">
					<template v-slot="{data}">
            <c-table-button power="b_decorate_template_pc_decorate" @click="navigateTo(`/decorate_manage/pc?id=${data.id}`, true)">装修</c-table-button>
            <c-table-button power="b_decorate_template_pc_decorate" @click="$refs.navList.open(data.template_name+'--导航管理',data.id)">导航管理</c-table-button>
            <c-table-button power="b_decorate_template_pc_edit" @click="copyTemplate(data)">复制</c-table-button>
            <c-table-button power="b_decorate_template_wx_edit" v-if="data.id > 0" @click="editTemplate(data)">编辑</c-table-button>
            <c-table-button power="b_decorate_template_wx_edit" v-if="data.id > 0 && data.state != 1" @click="deleteTemplate(data)">删除</c-table-button>
          </template>
				</c-table-column>
			</c-table>
		</module>
		<c-dialog ref="editTemplateDialog" :title="editState ? '编辑PC装修模板' : '新增PC装修模板'" width="750" @resolve="submitEditTemplate">
        <c-form ref="edit_form">
                <c-form-item type="hidden" name="support_flag" :value="support_flag"></c-form-item>
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="模板名称" name="template_name" required word="请输入模板名称，最多不超过50个字符"></c-form-item>
                <c-form-item type="datetime" label="生效时间" name="effective_start_date" required></c-form-item>
                <c-form-item type="textarea" label="备注" name="remark"></c-form-item>
        </c-form>
    </c-dialog>
		<c-dialog ref="copyTemplateDialog" :title="copyTemplateName" width="750" @resolve="submitCopyTemplate">
        <c-form ref="copy_form">
                <c-form-item type="hidden" name="support_flag" :value="support_flag"></c-form-item>
                <c-form-item type="hidden" name="template_id"></c-form-item>
                <c-form-item type="input" label="模板名称" name="template_name" required word="请输入模板名称，最多不超过50个字符"></c-form-item>
                <c-form-item type="datetime" label="生效时间" name="effective_start_date" required></c-form-item>
                <c-form-item type="textarea" label="备注" name="remark"></c-form-item>
        </c-form>
    </c-dialog>

    <nav-list ref="navList"></nav-list>
  </page>
</template>

<script>
  import {mapState} from 'vuex'
  import global from '@/assets/script/function';
  //导航管理
  import navList from '@/submodule/decorate_manage/pc_nav_list.vue'

	export default {
		name: 'm_decorate_template_pc',
		data() {
			return {
        support_flag:1,//模板类型 1=PC
        edit_url:'/decoration/template/edit',//编辑地址
        edit_msg:'编辑成功',//编辑提示
        editState: false,   //编辑或是新增  true=编辑  false=新增
				templateStateName: {
					0: '未生效',
					1: '生效中',
					2: '已过期'
				},
				templateState: [
				    {name: '未生效',value: 0},
				    {name: '生效中',value: 1},
				    {name: '已过期',value:2}
        ],
        copyTemplateName:''
      }
		},

		computed: {
		    ...mapState(['session'])
		},
    components: {
      navList
    },
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
        data.support_flag = this.support_flag;
				this.$refs.table.load({
					url: '/decoration/template/list',
          data
				});
			},
			/**打开 新增/编辑装修模板 弹窗**/
      editTemplate(data){
          // 清空表单数据
          this.$refs.edit_form.clear();
          if(data.id >0){
              this.editState = true;//编辑
              this.edit_url = '/decoration/template/edit';//编辑
              this.edit_msg = '编辑';
          }else{
              this.editState = false;//新增
              this.edit_url = '/decoration/template/add';//新增
              this.edit_msg = '新增';
          }
          this.$refs.editTemplateDialog.open();
          if(data.id && data.id>0){
              this.getTemplateDetail(data.id);
          }else {
            var new_template = {};
            new_template.support_flag=  this.support_flag;
            this.$refs.edit_form.set(new_template);
          }
      },
			/**打开 复制模板 弹窗**/
      copyTemplate(data){
          // 清空表单数据
          this.$refs.copy_form.clear();
          this.copyTemplateName = '复制模板('+data.template_name+')';
          this.$refs.copyTemplateDialog.open();
          var new_template = {};
          new_template.template_id=  data.id;
          new_template.support_flag=  this.support_flag;
          //赋值form
          this.$refs.copy_form.set(new_template);
      },
      /**查询模板详情**/
      getTemplateDetail(template_id){
          this.request({
              url: '/decoration/template/detail',
              data: {
                  id: template_id
              },
              success: data => {
                  if (!data) {
                      this.$message({
                          text: '模板不存在或已删除!'
                      });
                      return;
                  }
                //赋值form
                this.$refs.edit_form.set(data);
              }
          });
      },
      /**提交修改**/
      submitEditTemplate(stop){
         stop();
         this.$refs.edit_form.submit({
            url:this.edit_url,
            rule: {
              template_name: '请填写模板名称',
              effective_start_date: '请选择模板生效时间'
            },
            success: (data, res) => {
                //关闭弹窗
                this.$refs.editTemplateDialog.close();
                this.$message({
                  text: this.edit_msg+'模板成功！'
                });
                // 清空表单数据
                this.$refs.edit_form.clear();
                this.$refs.search.search();
            }
        });
      },
      /*复制模板**/
      submitCopyTemplate(data) {
        stop();
        this.$refs.copy_form.submit({
          url:'/decoration/template/copy',
          rule: {
              template_name: '请填写模板名称',
              effective_start_date: '请选择模板生效时间'
          },
          success: (data, res) => {
            //关闭弹窗
            this.$refs.copyTemplateDialog.close();
            this.$message({
              text: '复制模板成功！'
            });
            // 清空表单数据
            this.$refs.copy_form.clear();
            this.$refs.search.search();
          }
        });
      },
      /**删除模板**/
      deleteTemplate(data) {
          this.$confirm({
                  text: '确定要删除【'+data.template_name+'】吗？',  // 提示内容,
                  buttonName: '确定',  // 确定按钮文字
                  cancelButton: true,  // 是否显示取消按钮
                  resolve: () => {
                       this.request({
                           url: '/decoration/template/remove',
                           data: {
                               id: data.id
                           },
                           loading: true,
                           success: data => {
                               this.$message({
                                   text: '删除成功'
                               });
                               this.$refs.search.search();
                           }
                        });
                  },  // 确定按钮回调
                  cancel: () => {},  // 取消按钮回调
          });
      },
      /***跳转装修页面***/
      decorateHandle(data) {
          var dd = {};
          dd.session = this.session;
          var sign = global.encryption(dd);
          window.open(`/oms/decorate_platform/to_pc_index.html?type=wx&template_id=${data.id}&page_id=${data.home_page_id}&page_type=2&site_id=${data.site_id}&site_name=%E5%8D%8E%E4%B8%9C%E7%AB%99&ciphertext=${encodeURIComponent(sign.ciphertext)}&timestamp=${sign.timestamp}&sign=${sign.sign}`)
      }
		}
	}
</script>